import type {
  UpdateContractorRequest,
  UpdateContractorResult,
  UpdateContractorApiResponse,
} from "@onsemble/shared/types/internal";
import { TanstackError } from "../client";

/**
 * Update contractor metadata (customer ID, profit center, phone, address)
 */
export async function updateContractor(
  orgId: string,
  data: UpdateContractorRequest
): Promise<UpdateContractorResult> {
  const response = await fetch(`/api/internal/contractors/${orgId}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(data),
  });

  const result: UpdateContractorApiResponse = await response.json();

  if (!response.ok || !result.success) {
    throw new TanstackError(
      response.status,
      result.error || "Failed to update contractor"
    );
  }

  return result.data;
}
